export const mockAvailableZipCodeWithTags = {
  default: {
    zipCodeId: 16,
    zipCode: "91790",
    sicId: 111,
    usedTags: [
      {
        id: 6,
        name: "LG",
        description: "Liftgate",
        colorHex: "#679CB2",
        position: 40,
      },
      {
        id: 8,
        name: "LM",
        description: "Large Mark - 6 plts or greater-6,000 lbs or greater",
        colorHex: "#E280B4",
        position: 50,
      },
    ],
    unusedTags: [
      {
        id: 3,
        name: "CC",
        description: "Critical care shipment ",
        colorHex: "#EA5E5A",
        position: 10,
      },
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 20,
      },
      {
        id: 81,
        name: "VC",
        description: "Vendor Compliance",
        colorHex: "#AA7EA0",
        position: 30,
      },
      {
        id: 6,
        name: "LG",
        description: "Liftgate",
        colorHex: "#679CB2",
        position: 40,
      },
      {
        id: 8,
        name: "LM",
        description: "Large Mark - 6 plts or greater-6,000 lbs or greater",
        colorHex: "#E280B4",
        position: 50,
      },
      {
        id: 74,
        name: "RESI",
        description: "Residential",
        colorHex: "#6B8DEB",
        position: 60,
      },
      {
        id: 75,
        name: "OVL",
        description: "Overlength",
        colorHex: "#C77563",
        position: 70,
      },
      {
        id: 76,
        name: "LACC",
        description: "Limited Access",
        colorHex: "#DDB272",
        position: 80,
      },
      {
        id: 77,
        name: "INDL",
        description: "Inside Delivery",
        colorHex: "#9CA8E5",
        position: 90,
      },
      {
        id: 5,
        name: "APTM",
        description: "Appointment Made",
        colorHex: "#69ADA8",
        position: 100,
      },
      {
        id: 4,
        name: "APTR",
        description: "Appointment Required ",
        colorHex: "#777DE9",
        position: 110,
      },
      {
        id: 1,
        name: "WC",
        description: "Will Call",
        colorHex: "#C0CA33",
        position: 120,
      },
      {
        id: 84,
        name: "LQ",
        description: "Limited Quantity",
        colorHex: "#9E393B",
        position: 130,
      },
      {
        id: 78,
        name: "$$$",
        description: "Driver Collect",
        colorHex: "#AA7EA0",
        position: 140,
      },
      {
        id: 7,
        name: "OSAD",
        description: "Overage, Shortage or Damaged",
        colorHex: "#FF8F7A",
        position: 150,
      },
      {
        id: 79,
        name: "VOL",
        description: "Volume Shipment",
        colorHex: "#B39DDB",
        position: 160,
      },
      {
        id: 80,
        name: "TL",
        description: "Truckload Shipment",
        colorHex: "#80CAE2",
        position: 170,
      },
      {
        id: 9,
        name: "DTCL",
        description: "Delivery to Connecting Line",
        colorHex: "#5E9FE0",
        position: 180,
      },
      {
        id: 41,
        name: "PFCL",
        description: "Pickup From Connecting Line",
        colorHex: "#7DD696",
        position: 190,
      },
      {
        id: 82,
        name: "RSHP",
        description: "Reship",
        colorHex: "#3664A2",
        position: 200,
      },
      {
        id: 83,
        name: "ST",
        description: "Straight Truck",
        colorHex: "#7A9AAD",
        position: 210,
      },
      {
        id: 15,
        name: "DTFB",
        description: "Delivery to Freight Broker",
        colorHex: "#7A9AAD",
        position: 220,
      },
    ],
  },
};

export const mockCreateZipCodeWithTags = {
  default: {
    zipCodeId: 16,
    zipCode: "91790",
    shipmentTags: [
      {
        id: 3,
        name: "CC",
        description: "Critical care shipment ",
        colorHex: "#EA5E5A",
        position: 10,
      },
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 20,
      },
    ],
  },
};

export const mockUpdateZipCodeWithTags = {
  default: {
    zipCodeId: 1,
    zipCode: "93599",
    shipmentTags: [
      {
        id: 3,
        name: "CC",
        description: "Critical care shipment ",
        colorHex: "#EA5E5A",
        position: 10,
      },
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 20,
      },
    ],
  },
};
